import React from 'react';
import { Grid, Paper, Typography, Collapse } from '@mui/material';
import { GuidenceHintElement } from '../QuesOptFields';
import { useDispatch, useSelector } from 'react-redux';
import { CaretDownOutlined } from '@ant-design/icons';
import { MainState } from '../../../../../types/state';
import { getQuestionByPath } from '../../../../../helpers/utils';

const GuidanceHintGroup = (props: any) => {
  const dispatch = useDispatch();
  const defaultLanguage = useSelector((state: MainState) => state.language.defaultLanguage);
  const selectedQuestion = useSelector((state: MainState) => state.question.selectedQuestion);
  const selectedLanguage = useSelector((state: MainState) => state.language.selectedLanguageList);

  const questions = useSelector((state: MainState) => state.question.questions);
  const currentQuestion = getQuestionByPath(questions, selectedQuestion.path);

  return (
    <Grid container sx={{ p: 2 }}>
      <Paper sx={{ borderTop: 1, borderColor: 'grey.300', width: '100%', mr: '20px', pb: 1 }} elevation={2}>
        {' '}
        <Grid item style={{ color: 'grey' }}>
          <Grid
            container
            alignItems="center"
            direction="row"
            aria-label="settings"
            onClick={() => props.setCollapseHint(!props.collapseHint)}
          >
            <Typography style={{ color: 'grey', fontSize: 15 }} sx={{ p: 2 }}>
              Guidance Hint
            </Typography>
            <CaretDownOutlined />
          </Grid>
          <Collapse in={!props.collapseHint}>
            <Grid container>
              <Grid item xs={12}>
                <GuidenceHintElement
                  question={currentQuestion}
                  path={selectedQuestion.path}
                  code={defaultLanguage.code}
                  // onQuestionChange={props.onQuestionObjectChange}
                  isDefault={true}
                  dispatch={dispatch}
                />
              </Grid>
              {selectedLanguage.map((lang: any) => (
                <Grid xs={12} key={lang.code}>
                  <GuidenceHintElement
                    question={currentQuestion}
                    path={selectedQuestion.path}
                    // onQuestionChange={props.onQuestionObjectChange}
                    code={lang.code}
                    isDefault={false}
                    dispatch={dispatch}
                  />
                </Grid>
              ))}
            </Grid>
          </Collapse>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default GuidanceHintGroup;
